(function() {
    'use strict';

    angular
        .module('quantixApp')
        .controller('UserLoginDetailsController', UserLoginDetailsController);

    UserLoginDetailsController.$inject = ['$timeout', 'Auth','$uibModalInstance','$state','$rootScope','UserActivityService','$window','Principal','AuthServerProvider','$http','$sessionStorage'];

    function UserLoginDetailsController ($timeout, Auth,$uibModalInstance,$state,$rootScope,UserActivityService,$window,Principal,AuthServerProvider,$http,$sessionStorage) {
        var vm = this;
        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.lastlogincheck = lastlogincheck;
        vm.resetAccount = {};
        vm.success = null;
        vm.clear = clear;
       //var user=Principal.identity();
      // var username=user.$$state.value.login;
        function clear () {
        	delete $sessionStorage.Loginverification;
            $uibModalInstance.dismiss(true);
            Auth.logout();
            $state.go('login');
        }
        function lastlogincheck() {
        	delete $sessionStorage.Loginverification;
        	 $uibModalInstance.dismiss(true);
        	 var fd = new FormData();
        	 var saveorupdate="UpdateOrSave";
	    	   fd.append('update',saveorupdate);
        	 $http.post('api/userlogindetails',fd,{
					transformRequest : angular.identity,
					headers : {
						'Content-Type' : undefined
					}
				}).then(function(result){
					var data=result.data;
					if(data[0]=='UserDetailsSaved'){
						 $state.go('home');
					}
				})["catch"](function () {
					 Auth.logout();
	            });
        }
    }
})();
